import { AfterViewInit, Directive, ElementRef, EventEmitter, HostBinding, Input, OnDestroy, OnInit, Output } from '@angular/core'
import { TranslationService, WindowRef } from '@spartacus/core'
import { UcUnBlockedEvent } from '../components/shared/events/uc-un-blocked-event'
import { MbEventListenerService } from '../services/mb-event-listener/event-listener.service'
import { UcBlockableElementInitializedEvent } from '../components/shared/events/uc-blockable-element-initialized-event'
import { MbConstants } from '../../shared/mb-constants'
import { BehaviorSubject, Subscription } from 'rxjs'

@Directive({
  selector: '[mbUcBlockable]'
})
export class UcBlockableDirective implements OnInit, OnDestroy, AfterViewInit {

  private mutationObserver: MutationObserver | undefined
  private hasBlockedClass = false
  subscription = new Subscription()
  text$ = new BehaviorSubject<string>('')

  @Output() unBlocked = new EventEmitter<UcUnBlockedEvent>()
  @Output() block = new EventEmitter<string>()
  @Input() ucService: string | undefined
  @Input() ucId: string | undefined
  @Input() useBasicThumbnail: boolean = false

  @HostBinding('attr.data-uc-service') get dataUcService (): string {
    return this.ucService ?? ''
  }

  @HostBinding('attr.data-uc-id') get dataUcId (): string {
    return this.ucId ?? ''
  }

  @HostBinding('attr.data-use-basic-thumbnail') get dataUseBasicThumbnail (): boolean {
    return this.useBasicThumbnail
  }

  constructor (private elementRef: ElementRef,
               private winRef: WindowRef,
               private eventListener: MbEventListenerService,
               private translationService: TranslationService) {
  }

  ngOnInit (): void {
    if (this.winRef.isBrowser()) {
      this.observeBlockedClass()
    }
    this.subscription.add(this.translationService.translate('ucBlockedContent.consentForLinks')
      .subscribe(text => this.text$.next((text))))
  }

  ngAfterViewInit (): void {
    if (this.winRef.isBrowser()) {
      const element = this.elementRef.nativeElement as HTMLElement
      this.hasBlockedClass = Array.from(element.classList).indexOf('uc-blocked') > -1
      this.eventListener.update(new UcBlockableElementInitializedEvent(this.ucId ?? '', this.ucService as string, this.useBasicThumbnail))
    }
  }

  ngOnDestroy (): void {
    this.subscription?.unsubscribe()
    if (this.winRef.isBrowser()) {
      this.disconnectMutationObserver()
    }
  }

  observeBlockedClass (): void {
    this.mutationObserver = new MutationObserver((mutations: MutationRecord[]) => {
      mutations.forEach((mutation: MutationRecord) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class' && mutation.target === this.elementRef.nativeElement) {
          const target = mutation.target as HTMLElement
          const hasBlockedLinkClass = target.classList.contains(MbConstants.UC_SERVICE_BLOCK_LINK_CLASS)
          const hasBlockedClass = target.classList.contains(MbConstants.UC_SERVICE_BLOCK_CLASS) || hasBlockedLinkClass
          if (hasBlockedLinkClass) {
            this.block.emit(this.text$.value)
            this.eventListener.update(new UcBlockableElementInitializedEvent(this.ucId ?? '', this.ucService as string, this.useBasicThumbnail))
          }
          if (hasBlockedClass && !this.hasBlockedClass) {
            this.hasBlockedClass = true
          } else if (!hasBlockedClass && this.hasBlockedClass) {
            this.hasBlockedClass = false
            this.winRef.nativeWindow?.dispatchEvent(new UcUnBlockedEvent(this.ucId ?? '', this.ucService as string, this.useBasicThumbnail))
            this.unBlocked.emit(new UcUnBlockedEvent(this.ucId ?? '', this.ucService as string, this.useBasicThumbnail))
          }
        }
      })
    })

    const config = { attributes: true, attributeFilter: ['class'], subtree: true }
    this.mutationObserver.observe(this.elementRef.nativeElement, config)
  }

  disconnectMutationObserver (): void {
    if (this.mutationObserver) {
      this.mutationObserver.disconnect()
    }
  }
}
